export default "__VITE_ASSET__BjNVLx1g__"